import memoizeOne from 'react-utils/memoizeOne';
import { useUserInfo } from './useUserInfo';
export const memoizedGatesSet = memoizeOne(user => new Set(user === null || user === void 0 ? void 0 : user.gates));
export const useGate = gate => {
  const userInfoData = useUserInfo();
  const gates = memoizedGatesSet(userInfoData);
  return gates.has(gate);
};